import { useCallback } from 'react';
import { useSelector, useDispatch } from '../../react-redux';
import {
  setSipNumberAction,
  updateInCallAction,
  updateAllowCallAction,
  updateAnswerTypeAction,
  updateSipMessageAction,
  updateConnectingAction,
  updateMobileNumberAction,
  updateRegisterDataAction,
  updateCallingClientAction,
  updateSummaryConfigAction,
  updateCallAgentStatusAction,
  updateSoftSwitchMesageAction,
  updateJanusErrorMessageAction,
  updateSoftSwitchApplicationRegisteredAction,
  updateJssipMessageAction,
  updateUUidAction,
  updateToolBarShowInfoAction,
  updateActiveAgentStatusAction,
  updateSipRegisteredAction,
  updateCurrentCallInfoAction,
  updateFakeRecordAction,
  updateSelectedClientAction,
  updateCallReportAction
} from '../../reducers/call';

const useCallStore = () => {
  const dispatch = useDispatch();

  const toolBarShowInfo = useSelector(state => {
    return state.getIn(['call', 'toolBarShowInfo']);
  });

  const callingClient = useSelector(state => {
    return state.getIn(['call', 'callingClient']);
  });
  const sipNumber = useSelector(state => {
    return state.getIn(['call', 'sipNumber']);
  });
  const callAgentStatus = useSelector(state => {
    return state.getIn(['call', 'callAgentStatus']);
  });
  const sipMessage = useSelector(state => {
    return state.getIn(['call', 'sipMessage']);
  });
  const connecting = useSelector(state => {
    return state.getIn(['call', 'connecting']);
  });
  const inCall = useSelector(state => {
    return state.getIn(['call', 'inCall']);
  });
  const registerData = useSelector(state => {
    return state.getIn(['call', 'registerData']);
  });
  const allowCall = useSelector(state => {
    return state.getIn(['call', 'allowCall']);
  });
  const janusErrorMessage = useSelector(state => {
    return state.getIn(['call', 'janusErrorMessage']);
  });
  const summaryConfig = useSelector(state => {
    return state.getIn(['call', 'summaryConfig']);
  });
  const answerType = useSelector(state => {
    return state.getIn(['call', 'answerType']);
  });
  const mobileNumber = useSelector(state => {
    return state.getIn(['call', 'mobileNumber']);
  });
  const softSwitchMessage = useSelector(state => {
    return state.getIn(['call', 'softSwitchMessage']);
  });
  const softSwitchApplicationRegistered = useSelector(state => {
    return state.getIn(['call', 'softSwitchApplicationRegistered']);
  });

  // JsSip
  const jssipMessage = useSelector(state => {
    return state.getIn(['call', 'jssipMessage']);
  });

  const callUUID = useSelector(state => {
    return state.getIn(['call', 'uuid']);
  });
  const activeAgentStatus = useSelector(state => {
    return state.getIn(['call', 'activeAgentStatus']);
  });

  const sipRegistered = useSelector(state => {
    return state.getIn(['call', 'sipRegistered']);
  });

  const currentCallInfo = useSelector(state => {
    return state.getIn(['call', 'currentCallInfo']);
  });

  const fakeRecord = useSelector(state => {
    return state.getIn(['call', 'fakeRecord']);
  });

  const selectedClient = useSelector(state => {
    return state.getIn(['call', 'selectedClient']);
  });

  const callReport = useSelector(state => {
    return state.getIn(['call', 'callReport']);
  });

  const updateCallingClient = useCallback(client => {
    dispatch(updateCallingClientAction({ client }));
  }, []);
  const updateSipNumber = useCallback(sipNumber => {
    dispatch(setSipNumberAction({ sipNumber }));
  }, []);
  const updateCallAgentStatus = useCallback(status => {
    dispatch(updateCallAgentStatusAction({ status }));
  }, []);
  const updateSipMessage = useCallback(message => {
    dispatch(updateSipMessageAction({ message }));
  }, []);
  const updateConnecting = useCallback(connecting => {
    dispatch(updateConnectingAction({ connecting }));
  }, []);
  const updateInCall = useCallback(inCall => {
    dispatch(updateInCallAction({ inCall }));
  }, []);
  const updateRegisterData = useCallback(data => {
    dispatch(updateRegisterDataAction({ data }));
  }, []);
  const updateAllowCall = useCallback(value => {
    dispatch(updateAllowCallAction({ value }));
  }, []);
  const updateJanusErrorMessage = useCallback(obj => {
    dispatch(updateJanusErrorMessageAction({ obj }));
  }, []);
  const updateSummaryConfig = useCallback(config => {
    dispatch(updateSummaryConfigAction({ config }));
  }, []);
  const updateAnswerType = useCallback(type => {
    dispatch(updateAnswerTypeAction({ type }));
  }, []);
  const updateMobileNumber = useCallback(number => {
    dispatch(updateMobileNumberAction({ number }));
  }, []);
  const updateSoftSwitchMessage = useCallback(message => {
    dispatch(updateSoftSwitchMesageAction({ message }));
  });
  const updateSoftSwitchApplicationRegistered = useCallback(registered => {
    dispatch(updateSoftSwitchApplicationRegisteredAction({ registered }));
  });

  // JsSip
  const updateJssipMessage = useCallback(message => {
    dispatch(updateJssipMessageAction({ message }));
  }, []);

  const updateUUid = useCallback(uuid => {
    dispatch(updateUUidAction({ uuid }));
  }, []);

  const updateToolBarShowInfo = useCallback(data => {
    dispatch(updateToolBarShowInfoAction({ data }));
  }, []);

  const updateActiveAgentStatus = useCallback(data => {
    dispatch(updateActiveAgentStatusAction({ data }));
  }, []);

  const updateSipRegistered = useCallback(data => {
    dispatch(updateSipRegisteredAction({ data }));
  }, []);

  const updateCurrentCallInfo = useCallback(data => {
    dispatch(updateCurrentCallInfoAction({ data }));
  }, []);

  const updateFakeRecord = useCallback(data => {
    dispatch(updateFakeRecordAction({ data }));
  }, []);

  const updateSelectedClient = useCallback(data => {
    dispatch(updateSelectedClientAction({ data }));
  }, []);

  const updateCallReport = useCallback(data => {
    dispatch(updateCallReportAction({ data }));
  }, []);

  return {
    callUUID,
    inCall,
    sipNumber,
    allowCall,
    sipMessage,
    connecting,
    answerType,
    mobileNumber,
    registerData,
    callingClient,
    summaryConfig,
    callAgentStatus,
    janusErrorMessage,
    softSwitchMessage,
    softSwitchApplicationRegistered,
    toolBarShowInfo,
    activeAgentStatus,
    sipRegistered,

    // JsSip
    jssipMessage,
    currentCallInfo,
    fakeRecord,
    selectedClient,
    callReport,

    updateFakeRecord,
    updateCurrentCallInfo,
    updateSipNumber,
    updateInCall,
    updateAllowCall,
    updateSipMessage,
    updateAnswerType,
    updateConnecting,
    updateMobileNumber,
    updateRegisterData,
    updateCallingClient,
    updateSummaryConfig,
    updateCallAgentStatus,
    updateJanusErrorMessage,
    updateSoftSwitchMessage,
    updateSoftSwitchApplicationRegistered,

    // JsSip
    updateJssipMessage,
    updateUUid,
    updateToolBarShowInfo,
    updateActiveAgentStatus,
    updateSipRegistered,
    updateSelectedClient,
    updateCallReport
  };
};

export default { useCallStore };
